module.exports = __webpack_public_path__ + "static/media/img_hero-define-2.39a04074.png";